module.exports = __webpack_public_path__ + "files/1a8791e49cc0ebcc96186ebc554cfc16.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/icons/generic.png
 ** module id = 382
 ** module chunks = 0
 **/